function init() {

    function adjustHeroPosition() {
        // Ensure screen width is 1024px or greater
        if (window.innerWidth < 1024) return;

        // Select the target element
        const heroElement = document.querySelector(".interior-hero-clear");

        // If the element does not exist, exit
        if (!heroElement) return;

        // Select the header element
        const header = document.querySelector(".o-header");

        if (header) {
            // Change the background color to transparent
            header.style.backgroundColor = "transparent";

            const mainnav = document.querySelector(".o-header__main-menu-group");
            mainnav.style.paddingTop = "36px";

            // Get the height of the header
            const headerHeight = header.offsetHeight + 1; // Add 1 pixel

            // Apply negative top margin and additional top padding
            heroElement.style.marginTop = `-${headerHeight}px`;
            heroElement.style.paddingTop = `${headerHeight}px`;
        }
    }

    // Run on page load
    adjustHeroPosition();

    // Re-run when window resizes to ensure responsiveness
    window.addEventListener("resize", adjustHeroPosition);
    
}
export {init as default}